{
  "title": "How to reply about meals and use the help desk",
  "description": "Reply about lunch and the banquet, read notices and send a case to the organizer's help desk from the event page.",
  "headings": [
    "What you will accomplish",
    "Who this is for",
    "Before you start",
    "Steps",
    "Afterward",
    "FAQ"
  ],
  "summary": "When done the organizer has your lunch and banquet reply (used only to estimate numbers), and you can send a case and follow its status whenever you need help.",
  "roleNote": "Event attendees; meal replies and the help desk require sign-in",
  "prerequisites": [
    "A signed-in account",
    "Meal replies must be made before the deadline shown on the page (for TAAI 2026: 2026-11-16 23:59, UTC+08:00)"
  ],
  "pathLabel": "Event page → My services → Meals and banquet / Help desk (/events/:slug/meals, /events/:slug/help)",
  "steps": [
    {
      "title": "1. Reply about lunch and dietary needs",
      "description": "Open Meals and banquet, tick the days you will attend lunch, choose a dietary category (no special need, lacto-ovo vegetarian, vegan, halal, no beef, no pork, seafood allergy, nut allergy, other), add up to 200 characters of notes if needed and press Save. The page shows a countdown to the deadline and cannot be changed afterward. Notes are stored encrypted and are hidden from check-in staff and other users."
    },
    {
      "title": "2. Reply about the banquet",
      "description": "On the same page choose \"I will attend the banquet\" or \"I will not attend the banquet\" and save. This reply only helps the organizer estimate numbers; it is not banquet entitlement or proof of payment, which remain governed by the official TAAI registration."
    },
    {
      "title": "3. Read notices",
      "description": "Latest notices on the event page are marked General, Important or Critical and come in Chinese and English. Notices are information on the page; the organizer may additionally email people who hold a shuttle booking."
    },
    {
      "title": "4. Send a case to the help desk",
      "description": "Open Help desk, choose a category (transport, meals, registration, accessibility, lost property, other), enter a subject and description, and tick Urgent if it cannot wait. After pressing Send case, My cases shows its status: new, in progress, resolved or closed. You see only your own cases. For any threat to personal safety call 119 or 110 and tell on-site staff instead of waiting for a case."
    }
  ],
  "afterward": [
    "My itinerary on the event page shows meals and banquet as replied",
    "The organizer updates case status and you can return to My cases at any time"
  ],
  "nextSteps": "For the shuttle see \"How to reserve an event shuttle seat\".",
  "faq": [
    {
      "q": "Does replying about the banquet give me entitlement?",
      "a": "No. The reply is only used to estimate numbers; entitlement follows the official TAAI registration."
    },
    {
      "q": "What if I need to change my diet after the deadline?",
      "a": "The system no longer accepts changes after the deadline. Send a help desk case describing the change and the organizer will decide whether it can be handled."
    },
    {
      "q": "Who can see my dietary notes?",
      "a": "Notes are stored encrypted. Only the event owner or manager can export them (each export is audited) and the organizer dashboard shows only headcounts per dietary category. They are deleted 30 days after the event."
    }
  ],
  "figures": [
    {
      "name": "meals",
      "alt": "Meals and banquet reply: lunch days, dietary category and banquet attendance, editable until the deadline",
      "caption": "Meals and banquet reply: lunch days, dietary category and banquet attendance, editable until the deadline"
    },
    {
      "name": "help-desk",
      "alt": "Help desk: send a case by category and follow its status under My cases",
      "caption": "Help desk: send a case by category and follow its status under My cases"
    }
  ]
}
